import { Component, Input, OnInit } from '@angular/core';
import { NgxToastrService, UserService } from '@services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-policies-select',
  templateUrl: './policies-select.component.html',
  styleUrls: ['./policies-select.component.scss'],
})
export class PoliciesSelectComponent implements OnInit {
  @Input() company: any;
  @Input() user: any;
  @Input() policies: any[] = [];

  selectedPolicyUuid: string | null = null;
  loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private translate: TranslateService,
    private ngxToastrService: NgxToastrService
  ) {}

  ngOnInit(): void {
    this.selectedPolicyUuid = this.user?.travelPolicyUuid || null;
  }

  confirm() {
    if (!this.selectedPolicyUuid) {
      this.translate.get('group.group-form.error-edit-policies').subscribe((msg) => {
        this.ngxToastrService.typeError(null, msg);
      });
      return;
    }

    this.loading = true;
    this.userService
      .putUserPolicies(this.user.uuid, this.selectedPolicyUuid)
      .subscribe({
        next: () => {
          this.translate.get('group.group-form.success-edit-policies').subscribe((msg) => {
            this.ngxToastrService.typeSuccess(null, msg);
          });
          this.activeModal.close(this.selectedPolicyUuid);
        },
        error: (error) => {
          this.translate.get('group.group-form.error-edit-policies').subscribe((msg) => {
            this.ngxToastrService.typeError(null, msg);
          });
          this.loading = false;
        },
      });
  }

  closeModal() {
    this.activeModal.dismiss("Cross click");
  }
}
